import { render } from "./ModalFavoritesNickname.vue?vue&type=template&id=1acae646&scoped=true"
import script from "./ModalFavoritesNickname.vue?vue&type=script&lang=js"
export * from "./ModalFavoritesNickname.vue?vue&type=script&lang=js"

import "./ModalFavoritesNickname.vue?vue&type=style&index=0&id=1acae646&scoped=true&lang=css"

import exportComponent from "/Applications/XAMPP/xamppfiles/htdocs/dynamik_webapp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1acae646"]])

export default __exports__